import moment from 'moment';

const getDateLabel = date => moment.unix(date).format('MMM DD, YYYY');

export default getDateLabel;
